import React, {Component} from 'react'
import {Input} from 'reactstrap'
import PropTypes from 'prop-types'
import LoadingButton from "../LoadingButton";
import {Mutation} from 'react-apollo'
import _ from 'lodash'

import updateProjectInvoiceAmountLocalMutation from '../../../queries/client_side/mutations/update_project_invoice'
import removeProjectInvoiceMutation from '../../../queries/client_side/mutations/remove_project_invoice'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

export default class ProjectInvoicingTableRow extends Component {


    render() {

        const {
            project_id,
            name,
            project_status,
            project_clients,
            project_client_budgets,
            total_budget,
            total_fees,
            total_invoiced,
            total_credit_notes,
            total_writeoff,
            total_supplier_invoiced,
            amount_to_invoice,
            onSelected
        } = this.props


        return (
            <tr>
                <td>{project_id}</td>
                <td>{name}</td>
                <td>{project_status.description}</td>
                <td>{format(total_budget)}</td>
                <td>{format(total_fees)}</td>
                <td>{format(total_supplier_invoiced)}</td>
                <td>{format(total_budget - total_fees - total_supplier_invoiced)}</td>
                <td>{format(total_invoiced + total_credit_notes)}</td>
                <td>{format(total_writeoff)}</td>
                <td>{project_clients && project_clients.map(({client}) => {

                    const budgets = project_client_budgets.filter(budget => budget.client_id === client.client_id) || []
                    const totalAmountToInvoice = _.sumBy(budgets, 'amount_to_invoice')

                    return (<p>{client.name}: {format(totalAmountToInvoice)}</p>)
                })}</td>
                <td>

                    <div className="d-flex flex-row justify-content-end">
                        <LoadingButton
                            icon="edit"
                            className="square-btn"
                            loading={false}
                            size="sm"
                            color="warning"
                            onClick={() => {
                                //this.setState({editing: true})
                                onSelected(this.props)
                            }}
                        />
                        <Mutation mutation={removeProjectInvoiceMutation}>
                            {(removeProjectInvoiceMutationFunc) => (
                                <LoadingButton
                                    icon="times"
                                    className="square-btn ml-2"
                                    loading={false}
                                    size="sm"
                                    color="danger"
                                    onClick={() => {
                                        removeProjectInvoiceMutationFunc({variables: {project_id}})
                                    }}
                                />
                            )}
                        </Mutation>
                    </div>


                </td>
            </tr>
        )

    }

}

ProjectInvoicingTableRow.propTypes = {
    project_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    project_status: PropTypes.object.isRequired,
    project_clients: PropTypes.array,
    project_client_budgets: PropTypes.array,
    total_fees: PropTypes.number.isRequired,
    total_invoiced: PropTypes.number.isRequired,
    amount_to_invoice: PropTypes.number,
    onSelected: PropTypes.func.isRequired
}